import {Component, h} from "preact";
import {classes} from "mojave/classes";

/* eslint-disable jsdoc/valid-types */

/**
 * @typedef {{
 *      markers: MarkerPositioning.Marker[]
 *      onMarkerClick: function(MarkerPositioning.Marker),
 *      hovered: ?MarkerPositioning.Marker,
 *      onHoverEnter: function(MarkerPositioning.Marker),
 *      onHoverLeave: function(),
 * }} MarkerList.Props
 *
 * @typedef {{
 * }} MarkerList.State
 */
export class MarkerList extends Component
{
	/**
	 * @param {MarkerList.Props} props
	 * @returns {null|JSX.Element}
	 */
	render (props)
	{
		return (
			<ul class="list-group list-group-flush">
				{props.markers.map(marker => this.renderMarker(marker))}
			</ul>
		);
	}


	/**
	 * Renders a single marker list entry
	 *
	 * @private
	 * @param {MarkerPositioning.Marker} marker
	 * @returns {?JSX.Element}
	 */
	renderMarker (marker)
	{
		/** @type {MarkerList.Props} props */
		const props = this.props;

		return (
			<li
				class={classes({
					"list-group-item": true,
					"list-group-item-action": true,
					"list-group-item-info": null !== marker.x,
					"active": props.hovered === marker,
				})}
				onClick={() => this.props.onMarkerClick(marker)}
				onMouseEnter={() => props.onHoverEnter(marker)}
				onMouseLeave={() => props.onHoverLeave()}
			>
				{marker.label}
			</li>
		);
	}
}
